( function( $ ) {

$( function() {
  var page = $('#page-reset-password');
  if (page.length < 1) {
    return;
  }

  page.on( 'ajax:success', 'form.form', function( e, result ) {
    var boxEl = $('.box').empty();
    $($('#template-success').html()).appendTo(boxEl);
  });
});

})( jQuery );
